// @flow

import type {DictionaryItem, PaymentMethod} from '../../../containers/disputes/types';
import type {_Action, ActionCreator} from '../../types';

import {getPaymentMethods} from '../../../api/disputes';
import {getProjects} from '../../../api/projects';

const rootAct = '@publisher/disputes/dictionary';

export const SET_PAYMENT_METHOD = `${rootAct}/payment-method/set`;
export const SET_PROJECTS = `${rootAct}/projects/set`;

const setPaymentMethods = (payload): _Action<Array<PaymentMethod>> => ({
  type: SET_PAYMENT_METHOD,
  payload
});

const setProjects = (payload): _Action<Array<DictionaryItem>> => ({
  type: SET_PROJECTS,
  payload
});

export const fetchProjects = (merchantId: number): ActionCreator => dispatch => {
  getProjects({merchantId: merchantId, sort: 'desc'})
    .then(projects =>
      dispatch(
        setProjects(projects.map(project => ({id: project.id, name: project.name}: DictionaryItem)))
      )
    )
    .catch(() => dispatch(setProjects([])));
};

export const fetchPaymentMethodsWithInstances = (merchantId: number): ActionCreator => dispatch =>
  getPaymentMethods(merchantId)
    .then((paymentMethods: Array<PaymentMethod>) => dispatch(setPaymentMethods(paymentMethods)))
    .catch(() => dispatch(setPaymentMethods([])));
